<template>
  <div>
    <h3>General description</h3>
    <p>
      The constellation optimization mission allows to optimise different
      performances of a pre-existing constellation with user-defined
      constraints. The optimisation is processed by an enhanced genetic
      algorithm (EGA).
    </p>
    <h3>Hypothesis</h3>
    <p>The underlying assumptions for this module are the following:</p>
    <ul>
      <li>The Earth geometry is considered spherical</li>
      <li>Only circular orbits are considered</li>
      <li>
        The only perturbation taken into account is the oblateness of the Earth
        (<katex-element expression="J_2" /> harmonic of the potential)
      </li>
      <li>Payloads have circular fields of regard</li>
      <li>Earth meshes are rectangular</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipConstellationOptimizationMission'
}
</script>
